export default __webpack_public_path__ + "static/media/OSMOS_CALCE_120X120_desktop.0bd47f9c.jpg";